import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'
import Viewport from '../stores/viewport.js'
import App from '../stores/app.js'
import getOffsetTop from '../utilities/getOffsetTop.js'
import { easeInOutQuad } from '../utilities/easings.js'
import { gsap, Quad} from 'gsap'
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export default window.customElements.define(
  'verticals-nav',
  class extends CustomElement {
    constructor() {
      super()

      this.events = {
        'click .js-link': 'onClick'
      }

      this._verticals = []
      this._currentItem = 0
      this._navShow = false

      this._onResize = this.onResize.bind(this)
      this._onUpdate = this.onUpdate.bind(this)
    }

    connectedCallback() {
      super.connectedCallback()

      this.$links = Array.from(this.querySelectorAll('.js-link'))

      this.$verticals = Array.from(document.querySelectorAll('.js-vertical'))
      this.$sticky = this.querySelector('.js-verticals-nav-sticky')

      this.$verticals.forEach((el) => {
        this._verticals.push({
          el: el,
          offset: 0
        })
      })

      Emitter.on('resize', this._onResize)
      Emitter.on('update', this._onUpdate)

      this._onResize()
      this.onItemChange()
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      Emitter.off('resize', this._onResize)
      Emitter.off('update', this._onUpdate)
    }

    toggleShow(show) {
      this._navShow = show
      this.classList.toggle('is-out', !show)
    }

    onResize() {
      this._verticals.forEach((item, i) => {
        item.offset = getOffsetTop(item.el) - Viewport.svh / 2
      })
    }

    onUpdate() {
      if (this.scrollingTo) return

      if(window.scrollY >= this._verticals[0].offset && window.scrollY < this._verticals[this._verticals.length-1].offset + Viewport.svh) {
        if(this._navShow !== true) {
          this.toggleShow(true)
        }
      } else {
        if(this._navShow !== false) {
          this.toggleShow(false)
        }
      }

      this._verticals.every((item, i) => {
        const nextOffset = this._verticals[i + 1]
          ? this._verticals[i + 1].offset
          : Number.MAX_SAFE_INTEGER

        if (
          window.scrollY >= item.offset &&
          window.scrollY < nextOffset &&
          this._currentItem !== i
        ) {
          this._currentItem = i
          this.onItemChange()
          return false
        }

        return true
      })
    }

    onItemChange() {
      this.$links.forEach((el, i) => {
        if (i === this._currentItem) {
          el.classList.add('is-active')
        } else {
          el.classList.remove('is-active')
        }
      })
    }

    onClick(event) {
      event.preventDefault()

      this._currentItem = this.$links.findIndex((link) =>
        link.isEqualNode(event.currentTarget)
      )
      this.onItemChange()

      const target = document.getElementById(
        event.currentTarget.getAttribute('href').substr(1)
      )

      this.scrollingTo = true
      // App.lenis.scrollTo(target, {
      //   duration: 0.8,
      //   easing: easeInOutQuad,
      //   onComplete: () => {
      //     this.scrollingTo = false
      //   }
      // })

      gsap.to(window, { scrollTo: event.currentTarget.getAttribute('href'), duration: 1.2, ease: Quad.easeInOut, onComplete: () => {
        this.scrollingTo = false
      }})
    }
  }
)
